/**
 * Meta Pixel helper – wraps the global `fbq` function.
 * The base script is injected by <MetaPixel /> in the root layout.
 */

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const META_PIXEL_ID = '1314497747186394';

type FbqCommand = 'init' | 'track' | 'trackCustom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function fbq(command: FbqCommand, ...args: any[]) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(command, ...args);
  }
}

/** Fire the Lead standard event (e.g. after signup). */
export function trackLead() {
  fbq('track', 'Lead');
}

/**
 * Fire the Purchase standard event (e.g. after confirmed Stripe payment).
 * @param value  - The monetary value (e.g. 60 for $60/yr)
 * @param currency - ISO 4217 currency code, defaults to 'USD'
 */
export function trackPurchase(value: number, currency = 'USD') {
  fbq('track', 'Purchase', { value, currency });
}
